"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = __importDefault(require("./base"));
const errors_1 = require("@ledgerhq/errors");
const bjs = __importStar(require("bitcoinjs-lib"));
const base_2 = __importDefault(require("bs58check/base"));
const bs58check_1 = __importDefault(require("bs58check"));
const blake_hash_1 = __importDefault(require("blake-hash"));
const ripemd160_1 = __importDefault(require("ripemd160"));
const bs58_1 = __importDefault(require("bs58"));
const bip32_1 = __importDefault(require("./bip32"));
class Decred extends base_1.default {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor({ network }) {
        super({ network });
        this.network.dustThreshold = 10000;
        this.network.dustPolicy = "FIXED";
        this.network.usesTimestampedTransaction = false;
    }
    static blake256(buffer) {
        let b = buffer;
        if (buffer instanceof Uint8Array) {
            b = Buffer.from(buffer);
        }
        return (0, blake_hash_1.default)("blake256").update(b).digest();
    }
    // refer to decred spec https://devdocs.decred.org/developer-guides/addresses/
    static getAddressFromPk(publicKey) {
        const prefix = Buffer.from("073f", "hex");
        const pkhash = Buffer.concat([
            prefix,
            new ripemd160_1.default().update(Decred.blake256(publicKey)).digest(),
        ]);
        const checksum = Decred._blake256x2(pkhash).slice(0, 4);
        return bs58_1.default.encode(Buffer.concat([pkhash, checksum]));
    }
    toOutputScript(address) {
        if (!this.validateAddress(address)) {
            throw new errors_1.InvalidAddress();
        }
        const decodeBase58 = Decred.bs58check.decode(address, Decred._blake256x2);
        const prefix = address.toLocaleUpperCase().substring(0, 2);
        if (prefix === "DC") {
            return bjs.payments.p2sh({ hash: decodeBase58.slice(2) }).output;
        }
        else if (prefix === "DE" || prefix === "DS") {
            return bjs.payments.p2pkh({ hash: decodeBase58.slice(2) }).output;
        }
        throw new errors_1.InvalidAddress();
    }
    validateAddress(address) {
        if (address.length < 25 || address.length > 36) {
            return false;
        }
        try {
            Decred.bs58check.decode(address, Decred._blake256x2);
        }
        catch (error) {
            return false;
        }
        return true;
    }
    // get address given an address type
    customGetAddress(derivationMode, xpub, account, index) {
        return __awaiter(this, void 0, void 0, function* () {
            let buffer;
            try {
                buffer = Decred.bs58check.decode(xpub);
            }
            catch (_a) {
                buffer = bs58check_1.default.decode(xpub);
            }
            const depth = buffer[4];
            const i = buffer.readUInt32BE(9);
            const chainCode = buffer.slice(13, 45);
            const X = buffer.slice(45, 78);
            const hd = new bip32_1.default(X, chainCode, this.network, depth, i);
            const publicKey = (yield (yield hd.derive(account)).derive(index)).publicKey;
            return Decred.getAddressFromPk(publicKey);
        });
    }
}
Decred._blake256x2 = (buffer) => Decred.blake256(Decred.blake256(buffer));
Decred.bs58check = (0, base_2.default)(Decred._blake256x2);
exports.default = Decred;
//# sourceMappingURL=decred.js.map